export const STAGE_INITIAL = 'INITIAL';
export const STAGE_CUSTOM_PAGE = 'CUSTOM_PAGE';
export const STAGE_SELECT_TEMPLATE = 'SELECT_TEMPLATE';
